/**
 * Deals with coupons labels
 */
export class CouponLabels {
  /**
   * @constructor
   */
  constructor(
    public discountValue: string = 'discount-value', // NOSONAR
    public expiresOn?: string,
    public couponValidCountry: string = 'coupon-valid-country' // NOSONAR
  ) {}
}
